import { _ep0, _mw0, command } from "../commandBuilder";
import { DeleteInvitation$ } from "../schemas/schemas_0";
export class DeleteInvitationCommand extends command(_ep0, _mw0, "DeleteInvitation", DeleteInvitation$) {
}
